import React from 'react'
import Header from '../inc/Header'
import Profile from './Profile'

function Profilepage() {
  return (
    <div>
      <Header />
      <br />
      <br />
      <br />
      <br />
      <div className='newvack'>
        <br />
        <br />
        <div className="album py-3">
          <div className="container">

            <h2 style={{ color: "white" }}>Leadership at THE LOVE BIRD'S</h2>
            <p style={{ color: "white" }}>At The Love Bird's Icecream Parlour, we believe that ice cream is more than just a treat—it's an experience</p>
            <br />
            <br />
          </div>
        </div>
      </div>
      <br />

      <Profile />
    </div>
  )
}

export default Profilepage